<template>
<div style="display:none"> {{test}}</div>
	<div class="container">

	<!-- <div class="navSection">1</div> -->
	<div class="signNameSection"><h1>{{ activeSignProfile.signName }}</h1></div>
	<div class="signDetailSection">
		<div class="signItemContainerRow" :class="[activeSignProfile.family === 'Fire' ? 
				'fireBg':
				activeSignProfile.family === 'Earth'? 'earthBg' :
				activeSignProfile.family === 'Air'? 'airBg' : 
				activeSignProfile.family === 'Water'? 'waterBg' : null]">
			
			<div class="signDetailItem" v-on:click="`${getDefaultInfo()}`">
						<div class="signItemIcon">{{ activeSignProfile.glyphDisplayCharacter }}</div>
						<div class="signItemBtnName">About {{ activeSignProfile.signName }}</div>
					</div>

					<div class="signDetailItem" v-on:click="loadContent('element', `${activeSignProfile.signId}`)">
						<div class="signItemIcon">{{ activeSignProfile.elementDisplayCharacter }}</div>
						<div class="signItemBtnName">About {{ activeSignProfile.family }} Signs</div>
					</div>			

					<div class="signDetailItem" v-on:click="loadContent('quality', `${activeSignProfile.signId}`)">
						<div class="signItemIcon">{{ activeSignProfile.qualityDisplayCharacter }}</div>
						<div class="signItemBtnName">About {{ activeSignProfile.quality }} Signs</div>
					</div>

					<div class="signDetailItem" v-on:click="loadContent('house', `${activeSignProfile.signId}`)">
						<div class="signItemIcon">{{ activeSignProfile.houseDisplayCharacter }}</div>
						<div class="signItemBtnName">About House {{ activeSignProfile.house }}</div>
					</div>

					<div class="signDetailItem" v-on:click="loadContent('planet', `${activeSignProfile.signId}`)">
						<div class="signItemIcon">{{ activeSignProfile.planetDisplayCharacter }}</div>
						<div class="signItemBtnName">About {{ activeSignProfile.planet }} </div>
					</div>

		</div>

	</div>
	<div class="bodySection">
		<div class="contentArea">
			<ContentDescription />
			<!-- <h2>Landscape About Sign Detail Here</h2> -->
			<!-- <div class="iconDisplay">X</div> -->
		<!-- Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. -->
		</div>

</div>
	</div>

</template>

<script>
import { mapState } from 'vuex';
import ContentDescription from '@/components/views/ContentDescription.vue';

export default {
  data: () => {
    return {
		name: 'ProfilePortraitMode',
		props: {

      }
    }
  },
	methods: { loadContent: function (detailTypeIs, detailIdIs){ 
		let detailType = detailTypeIs; 
		let detailId = detailIdIs;
		console.log('load content', detailType, detailId);
		this.$store.dispatch('getZodiacDetail', {detailType, detailId});
		},	
		getDefaultInfo: function ( ){
			let selectedProfile = this.$store.getters.filterZodiacData(this.$route.params.signId)
			console.log('methods selectedProfile is: ', selectedProfile)
			return this.$store.dispatch('getZodiacSignProfile', selectedProfile)
		},
		unknownParameter: function () {
			return this.$router.push({name:'NotFound'});
		}

  },
  computed: {
    ...mapState(['zodiacData', 'getZodiacSignProfile', 'currentSignProfile', 'activeSignProfile']),
    test() {


      let selectedProfile = this.$store.getters.filterZodiacData(this.$route.params.signId)

	
	// ORIG CONFIG
    //   console.log('computed selectedProfile is: ', selectedProfile)
    //     return this.$store.dispatch('getZodiacSignProfile', selectedProfile)

	let dispatchProfile;

	//NEW CONFIG
	if (selectedProfile === undefined) {
        // console.log('portView reroute data to not fount page')
		// return this.unknownParameter()
      } else {
      console.log('portView computed selectedProfile is: ', selectedProfile)
         dispatchProfile = this.$store.dispatch('getZodiacSignProfile', selectedProfile)
        
		// return dispatchProfile;
        // return this.$store.dispatch('getZodiacSignProfile', selectedProfile)
      }

		return dispatchProfile, console.log( 'port default return')
        // return this.$store.dispatch('getZodiacSignProfile', selectedProfile)

      


	}
    },

    components: { ContentDescription
  }
}


</script>


<style scoped>
body {
		margin: 0;
		padding: 0;
		border: 0;
		overflow: hidden;
	}
.container {
    flex-direction:column;
	display: flex;
}
.buttonTxt, a, .signDisplayName, .container{
    color:white;
    text-shadow: -1px 0px 3px rgba(0, 0, 0, 1);
}

	.navSection{
		width: 100%;
		/* background-color: red; */
		/*padding: 5px;*/
		height: 10vh;
		margin: 0;
		flex-grow: 1;

	}
	.signNameSection{
		width: 100%;
		/* background-color: green; */
		height: 9vh;

		/*padding: 5px;*/
		/*min-height: 5vh;*/
		/*max-height: 20vh;*/
		/*text-align: center; */
		margin: 0;
		flex-grow: 1;
	}
	.signDetailSection{
		height: 10vh;
		width: 100%;
		/* background-color: yellow; */
		/*padding: 5px;*/
		min-height: 5vh;
		/*max-height: 20vh;*/
		margin: 0;
		justify-content: center;
        flex-grow: 1;
		display: contents;
	}
	.bodySection{
		height: 70vh;

		width: 100%;
		/* background-color: blue; */
		padding: 5px 0;
		/*height: 100vh;*/
		margin: 0;
		flex-grow: 4;
		overflow: auto;
	}
.fireBg {
    background: url('../../assets/img/fireBg.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
	background-size: cover;

}
.earthBg {
    background: url('../../assets/img/earthBg.jpg') no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
	background-size: cover;

}
.airBg {
    background: url('../../assets/img/airBg.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
	background-size: cover;

}
.waterBg {
    background: url('../../assets/img/waterBg.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
	background-size: cover;

}
.signDetailItem {
  background-color: rgba(0, 0, 0, 0.6);

  /* background: tomato; */
  padding: 5px 0;
  width: 100px;
  height: 10vh;
  margin: 0 10px;
  /*line-height: 10vh;*/
  color: white;
  /*font-weight: bold;*/
  text-align: center;
  cursor:pointer;
  flex-direction: column;
    transition: all ease 0.5s;
}
.signDetailItem:hover{
  background-color: rgba(0, 0, 0, 0.4);
}


.signItemContainerRow {
	background-color: pink;
  padding: 2px;
  margin: 0;
  list-style: none;
  /*border: 1px solid silver;*/
  -ms-box-orient: horizontal;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  justify-content: center;

}

.signItemIcon {
	display:block;
	font-family: "BOSAstrology";
font-size: 5vh;
}
.signItemBtnName {
font-size: 2vw;
line-height: 2vw;
display:block;
}
.contentArea{
	padding: 10px 20px;
}
h1 {
	text-align: center;
	font-size: 8vh;
	line-height: 8vh;
    display: block;
    font-size: 2em;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
    font-weight: bold;
}
h2{
	display: block;
    font-size: 6vh;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
	text-align: center;
    font-weight: bold;
}
.iconDisplay{
	text-align: center;
	font-size: 30vh;
	line-height: 30vh;
}
</style>